import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import loginLeftBg from "../../assets/images/login-bgndLeft.jpg";
import "./Login.css"; 

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const dashboard = queryParams.get("dashboard");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter email and password.");
      return;
    }

    try {
      const response = await axios.post("/post-fake-login", { email, password });
      console.log("Login successful:", response.data);
      navigate(dashboard ? `/questions?dashboard=${dashboard}` : "/questions");
    } catch (err) {
      setError("Invalid email or password.");
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-gradientLogin">
      <div className="row w-100 h-100">
        {/* Left Panel */}
        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div className="login-box">
            <h2 className="text-dark">Login</h2>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="text-dark">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="text-dark">Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button className="btn btn-success w-100">Login</button>
            </form>
            <p className="text-center mt-3">
              Don't have an account? <a href="/register" className="text-success">Create Account</a>
            </p>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-md-6 right-panel d-none d-md-block">
          <img src={loginLeftBg} alt="Background" className="img-fluid vh-100 object-fit-cover w-100" />
        </div>
      </div>
    </div>
  );
};

export default Login;



// import PropTypes from 'prop-types';
// import React, { useState, useEffect } from "react";

// import { Row, Col, CardBody, Card, Container, Label, Form, FormFeedback, Input } from "reactstrap";

// // Redux
// import { connect, useSelector, useDispatch } from "react-redux";
// import { Link } from 'react-router-dom';
// import withRouter from 'components/Common/withRouter';

// // Formik validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// // actions
// import { loginUser, apiError } from "../../store/actions";

// // import images
// import logoSm from "../../assets/images/logo-sm.png";
// import logoSm1 from "../../assets/images/112x80.png"

// const Login = props => {
//   const dispatch = useDispatch();

//   const [userLogin, setUserLogin] = useState([]);

//   const { user } = useSelector(state => ({
//     user: state.Account.user,
//   }));

//   useEffect(() => {
//     if (user && user) {
//       setUserLogin({
//         email: user.email,
//         password: user.password
//       });
//     }
//   }, [user]);

//   const validation = useFormik({
//     // enableReinitialize : use this flag when initial values needs to be changed
//     enableReinitialize: true,

//     initialValues: {
//       email: userLogin.email || "admin@themesbrand.com" || '',
//       password: userLogin.password || "123456" || '',
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your User Name"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: (values) => {
//       dispatch(loginUser(values, props.router.navigate));
//     }
//   });

//   document.title = "Login | Bvo -Dashboard";
//   return (
//     <React.Fragment>
//       <div className="home-btn d-none d-sm-block">
//         <Link to="/" className="text-dark">
//           <i className="fas fa-home h2" />
//         </Link>
//       </div>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={4}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary">
//                   <div className="text-primary text-center p-4">
//                     <h5 className="text-white font-size-20">
//                       Welcome Back !
//                     </h5>
//                     <p className="text-white-50">
//                       Sign in to continue to Bvo.
//                     </p>
//                     <Link to="/" className="logo logo-admin">
//                       <img src={logoSm1} height="24" alt="logo" />
//                     </Link>
//                   </div>
//                 </div>

//                 <CardBody className="p-4">
//                   <div className="p-3">
//                     <Form className="mt-4"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                       action="#">

//                       <div className="mb-3">
//                         <Label className="form-label" htmlFor="username">Username</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter Username"
//                           type="email"
//                           id="username"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email ? true : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label" htmlFor="userpassword">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           className="form-control"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password && validation.errors.password ? true : false
//                           }
//                         />
//                         {validation.touched.password && validation.errors.password ? (
//                           <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3 row">
//                         <div className="col-sm-6">
//                           <div className="form-check">
//                             <input type="checkbox" className="form-check-input" id="customControlInline" />
//                             <label className="form-check-label" htmlFor="customControlInline">Remember me</label>
//                           </div>
//                         </div>
//                         <div className="col-sm-6 text-end">
//                           <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Log In</button>
//                         </div>
//                       </div>

//                       <div className="mt-2 mb-0 row">
//                         <div className="col-12 mt-4">
//                           <Link to="/forgot-password"><i className="mdi mdi-lock"></i> Forgot your password?</Link>
//                         </div>
//                       </div>

//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 <p>
//                   Don&#39;t have an account ?
//                   <Link
//                     to="/register"
//                     className="fw-medium text-primary"
//                   >
                    
//                     Signup now
//                   </Link>
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Bvo. Crafted with
//                   <i className="mdi mdi-heart text-danger" /> by Tussle
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// const mapStateToProps = state => {
//   const { error } = state.Login;
//   return { error };
// };

// export default withRouter(
//   connect(mapStateToProps, { loginUser, apiError })(Login)
// );

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
// };
